export default {
  "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["about"])},
  "Price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price:"])},
  "شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saturday"])},
  "یکشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sunday"])},
  "دوشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["monday"])},
  "سه شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tuesday"])},
  "چهارشنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wednesday"])},
  "پنج شنبه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thursday"])},
  "جمعه": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Friday"])},
  "باز": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open"])},
  "بسته": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])}
}